<template>
  <div class="groupCode">
    <innerWarp v-if="$store.state.isMobile">
      <slot>
        <div v-if="!showSuccess && !showAddMember" class="content">
          <div class="title">请输入团队邀请码</div>
          <div class="inputCode">
            <el-input
              v-model="codes[n - 1]"
              maxlength="1"
              type="number"
              oninput="if(value.length>1)value=value.slice(0,1)"
              :ref="`inputItem_${n}`"
              @input="changeCode(n)"
              v-for="n in 4"
              :key="`index-${n}`"
              @focus="focusCode(n)"
              
            />
            <div :class="`inputWarp warp_${n} ${n == codeActiveIndex ? 'focused' : ''}`" v-for="n in 4" :key="n"></div>
          </div>
          <div class="buttonConfirm" @click="submitData">确&nbsp;定</div>
        </div>
        <div v-if="showAddMember && !showSuccess" class="codeAddMember">
          <addMember @submitAdd="submitAdd" :editData="editData" addType="add"></addMember>
        </div>
        <div v-if="showSuccess" class="content">
          <img src="~@/assets/wen_write.png"/>
          <div class="title">信息提交成功</div>
          <!-- <div class="buttonConfirm" @click="toIndex">返回主页</div> -->
        </div>
      </slot>
    </innerWarp>
    <div v-else class="pcWarp">
      <topBanner></topBanner>
      <div v-if="!showSuccess && !showAddMember" class="content">
        <div class="title">请输入团队邀请码</div>
        <div class="inputCode">
          <el-input
            v-model="codes[n - 1]"
            maxlength="1"
            type="number"
            oninput="if(value.length>1)value=value.slice(0,1)"
            :ref="`inputItem_${n}`"
            @input="changeCode(n)"
            v-for="n in 4"
            :key="`index-${n}`"
            @focus="focusCode(n)"
          />
          <div :class="`inputWarp warp_${n} ${n == codeActiveIndex? 'focused' : ''}`" v-for="n in 4" :key="n"></div>
        </div>
        <div class="buttonConfirm" @click="submitData">确&nbsp;定</div>
      </div>
      <div v-if="showAddMember" class="codeAddMember">
        <addMember @submitAdd="submitAdd" :editData="editData" addType="add"></addMember>
      </div>
      <div v-if="showSuccess" class="content">
        <img src="~@/assets/wen_write.png"/>
        <div class="title">信息提交成功</div>
        <div class="buttonConfirm" @click="toIndex">返回主页</div>
      </div>
    </div>
  </div>
</template>

<script>
import innerWarp from '../../components/common/innerWarp.vue'
import addMember from '../../components/ticket/addMember.vue'
import topBanner from '../../components/common/topBanner'

export default {
  data() {
    return {
      code: '',
      showSuccess: false,
      editData: {},
      showAddMember: false,
      codes: [],
      codeActiveIndex: 1
    };
  },

  components: {innerWarp, addMember, topBanner},


  methods: {
    submitAdd(data) {
      if (this.addType == 'edit') return this.editPersonal(data)
      for (let key in data) {
        if (!data[key]) {
          return this.$message.error('请将个人信息填写完整！')
        }
      }
      this.postAddPersonal(data)
    },

    postAddPersonal(data) {
      data.museumCode = this.$route.query.museumCode
      data.cardType = 1
      data.belongId = this.$route.query.belongId
      data.personType = 1
      this.$ajax.post(`/api/ticket/front/people/team-people?code=${this.code}`, data).then((res) => {
        this.showSuccess = true
      })
    },

    submitData() {
      this.code = this.codes.join('')
      this.$ajax(`/api/ticket/front/people/verify-code?code=${this.code}&id=${this.$route.query.belongId}`).then((res) => {
        this.showAddMember = true
      })
    },

    toIndex() {
      this.$router.replace(`/ticket/home?museumCode=${this.$route.query.museumCode}`)
    },

    changeCode(n) {
      // if (val.length == 1) {
        // console.log(this.$refs.inputItem)
      if (!this.codes[n - 1]) return
      this.$refs[`inputItem_${n+1}`] ? this.$refs[`inputItem_${n+1}`][0].focus() : ''
      // }
    },
    focusCode(n) {
      this.codeActiveIndex = n
    }
  },

  created() {
    
  },

  computed: {
  
  }
}
</script>

<style scoped lang="scss">
.groupCode{
  .content{
    margin-top: 1rem;
  }
  .title{
    // margin-top: 2rem;
    font-size: 0.6rem;
    font-weight: 500;
  }
  .el-input{
    display: inline-block !important;
    width: 1.4rem;
    margin: 0.5rem 0;
    margin-right: 0.35rem;
  }
}
</style>
<style type="text/css" lang="scss">
  .groupCode .inputCode input{
    border: unset !important;
    // letter-spacing: 1.19rem;
    // margin: 0.5rem;
    width: 1.4rem;
    height: 2rem;
    font-size: 1rem;
    line-height: 1.88rem;
    font-weight: 500;
    background-color: rgba(0,0,0,0);
    z-index: 5;
    outline: none;
    // padding-left: 0.42rem;
    text-align: center;
  }
  .groupCode .el-input{
    background-color: rgba(0,0,0,0);
    z-index: 5;
  }
  .groupCode .inputCode{
    position: relative;
    margin: 0.5rem 0 0.5rem 0.5rem;
    // margin-left: 0.5rem;
  }
  .inputWarp{
    height: 1.8rem;
    width: 1.4rem;
    border-radius: 0.4rem;
    border: 1px solid #e5e5e5;
    position: absolute;
    top: 0.6rem;
    z-index: -1;
  }
  .warp_1 {
    left: 1.25rem;
  }
  .warp_2{
    left: 3rem;
  }
  .warp_3{
    left: 4.75rem;
  }
  .warp_4{
    left: 6.55rem;
  }
  .groupCode{
    img{
      width: 4rem;
      // margin-top: 1rem;
    }
  }
  .groupCode{
    .pcWarp{
      .content{
        .el-input{
          width: 0.5rem;
          margin-right: 0.54rem;
          float: left;
          text-align: left;
          &:nth-child(1){
            margin-left: 1.2rem;
          }
        }
        margin-top: 0.2rem;
        .title{
          font-size: 0.3rem;
        }
        img{
          width: 110px;
          height: 154px;
        }
        .inputCode{
          margin-top: 0.1rem;
          width: 6rem;
          margin: auto;
          input{
            height: 1.2rem;
            width: 0.4rem;
            padding-left: 0.1rem;
            line-height: 1rem;
            font-size: 0.5rem;
            padding-right: 0;
            // letter-spacing: 0.7rem;
          }
          overflow: hidden;
        }
        .inputWarp{
          width: 0.5rem;
          height: 1rem;
        }
        .warp_1{
          left: 1.2rem;
        }
        .warp_2{
          left: 2.23rem;
        }
        .warp_3{
          left: 3.26rem;
        }
        .warp_4{
          left: 4.29rem;
        }
        .buttonConfirm{
          width: 1.8rem;
          height: 0.5rem;
          line-height: 0.5rem;
          font-size: 0.3rem;
        }
      }
    }
  }
</style>

<style lang="scss">
  .codeAddMember input{
    width: 4rem !important;
    height: 1rem !important;
    letter-spacing: unset !important;
    margin: unset;
  }
  .groupCode .pcWarp .pcMember{
    .itemCard{
      width: 50%;
      margin: auto;
      margin-top: 60px;
      .lineContent{
        font-size: 16px;
        .name{
          font-size: 18px;
          width: 130px;
        }
        input{
          height: 42px !important;
          width: 100% !important;
          font-size: 18px !important;
        }
      }
    }
    .contentTitle{
      margin: 20px;
      font-size: 24px;
      text-align: center;
    }
    .buttonNormalConfirmSmallContain{
      transform: scale(0.5);
    }
  }
</style>






